import { SecShape, type SecondaryDef } from '../../sim/secondary';

/** S02 — DRONES FLANQUEURS. La réponse au seul angle mort structurel du jeu.
 *
 *  ── Le besoin ────────────────────────────────────────────────────────────
 *  Tout tire vers le haut dans ce jeu : la primaire, la Lance, le Faisceau. Or
 *  le Rôdeur TRAVERSE latéralement à hauteur constante (voir rodeur.def.ts), et
 *  le duo Faucheur + Rôdeur porte 60 % des vagues du plan. Un ennemi qui passe
 *  à côté du vaisseau est littéralement intouchable tant que le joueur ne s'est
 *  pas replacé sous lui — et se replacer, c'est traverser le rideau qu'on était
 *  précisément en train d'esquiver.
 *
 *  Cette arme n'achète pas des dégâts, elle achète le DROIT DE RESTER. C'est
 *  pour ça que son DPS est le plus bas des quatre (82, soit 41 % de la
 *  primaire) et que c'est parfaitement défendable : sa valeur ne se mesure pas
 *  en dégâts mais en déplacements qu'on n'a pas eu à faire.
 *
 *  ── Pourquoi une recharge courte ─────────────────────────────────────────
 *  4 s, la plus courte du catalogue. Une arme réactive doit être disponible
 *  quand la situation apparaît, pas huit secondes plus tard : à recharge longue
 *  elle ne serait jamais prête au bon moment et le joueur se replacerait quand
 *  même — l'arme existerait sans être jouée. */
const flanqueurs: SecondaryDef = {
  id: 'drones-flanqueurs',
  name: 'Drones flanqueurs',
  shape: SecShape.Flanc,
  cooldown: 4,
  shots: 1,
  shotEvery: 0,
  // Par côté : 3 à gauche, 3 à droite.
  count: 3,
  // Les drones naissent à 34 u du fuselage. Assez loin pour se lire comme deux
  // essaims distincts plutôt que comme un élargissement du vaisseau — la
  // silhouette du joueur ne doit jamais devenir ambiguë, c'est elle qu'il
  // regarde pour esquiver.
  spacing: 34,
  // ±13° autour de l'horizontale. Un cône, pas trois lignes parallèles : à
  // 400 u de distance il couvre 180 u de haut, là où des parallèles laisseraient
  // les mêmes trois trous à toute distance.
  spreadDeg: 26,
  speed: 1300,
  radius: 12,
  damage: 55,
  text: '2 × 3 × 55 dégâts sur les flancs — 4 s',
};

export default flanqueurs;
